import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { sidebarActive } from '@Lib/slices/uiSlice';

function MenuItem({ item, handleClickItem }) {
  const routeMatch = useRouteMatch();
  const dispatch = useDispatch();

  useEffect(() => {
    if (routeMatch.path === item.path) {
      dispatch(sidebarActive(item.id));
    }
  }, []);

  return (
    <li className="nav-item">
      {item.isExternal ? (
        <a
          href={
            item.path.includes('hr.vvg.io.vn') ?
              (() => {
                const base = item.path.replace('/login', '');
                const token = localStorage.getItem(process.env.TOKEN);
                return `${base}/auth/callback?token=${token}&redirect=/dashboard`;
              })()
              : item.path
          }
          target="_blank"
          rel="noreferrer"
          className={`nav-link ${item.isActive ? 'active' : ''}`}
        >
          <span className="menu-item-content position-relative d-flex align-items-center">
            {item.icon && <span className="mr-50">{item.icon}</span>}
            {item.name}
            {item.badge && (
              <span
                className="badge badge-pill badge-light-danger"
                style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-18px',
                  fontSize: '8px',
                  padding: '2px 4px',
                  lineHeight: '1',
                }}
              >
                {item.badge}
              </span>
            )}
          </span>
        </a>
      ) : (
        <NavLink
          onClick={() => handleClickItem(item)}
          className={`${item.isActive ? 'active' : ''}`}
        >
          <span className="menu-item-content position-relative d-flex align-items-center">
            {item.icon && <span className="mr-50">{item.icon}</span>}
            {item.name}
            {item.badge && (
              <span
                className="badge badge-pill badge-light-danger"
                style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-18px',
                  fontSize: '8px',
                  padding: '2px 4px',
                  lineHeight: '1',
                }}
              >
                {item.badge}
              </span>
            )}
          </span>
        </NavLink>
      )}
    </li>
  );
}

MenuItem.propTypes = {
  item: PropTypes.object,
  handleClickItem: PropTypes.func,
};

export default MenuItem;
